export default __webpack_public_path__ + "static/media/header_bg.d6659aff.png";